import {
  addDoc,
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  query,
  where,
  orderBy,
} from 'firebase/firestore';
import { db } from '../firebase/firestore';

export const createModel = (schema) => {
  const parseDoc = async (docSnap) => {
    const parsed = { id: docSnap.id, ...docSnap.data() };

    if (schema.parse) {
      return await schema.parse(parsed);
    }

    return parsed;
  };

  return {
    schema,
    getTitle: doc => (
      typeof schema.getTitle === 'function'
        ? schema.getTitle(doc)
        : doc.name || doc.title || doc.id || 'Untitled'
    ),
    get: async (id) => {
      const docRef = doc(db, schema.collectionName, id);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        return null;
      }

      return parseDoc(docSnap);
    },
    list: async ({
      where: whereClauses,
      orderBy: orderByClauses,
    } = {}) => {
      const args = [collection(db, schema.collectionName)];

      if (whereClauses) {
        whereClauses.forEach(([field, operator, value]) => {
          args.push(where(field, operator, value));
        });
      }

      if (orderByClauses) {
        orderByClauses.forEach(([field, direction]) => {
          args.push(orderBy(field, direction));
        });
      }

      const querySnap = await getDocs(query(...args));
      return Promise.all(querySnap.docs.map(docSnap => parseDoc(docSnap)));
    },
    create: (data) => {
      return addDoc(collection(db, schema.collectionName), {
        ...data,
        createdAt: new Date(),
        updatedAt: new Date(),
      });
    },
    update: (id, data) => {
      const docRef = doc(db, schema.collectionName, id);
      return updateDoc(docRef, {
        ...data,
        updatedAt: new Date(),
      });
    },
    validate: (data) => {
      const errors = Object.keys(schema.properties).reduce(
        (memo, key) => {
          if (!schema.properties[key].validate) {
            return memo;
          }

          const validationResult = schema.properties[key].validate(data[key]);

          if (validationResult !== true) {
            memo.push({ key, validationError: validationResult });
          }

          return memo;
        },
        [],
      );

      return errors;
    },
  };
};
